import { loadStripe } from "@stripe/stripe-js";

import { safeLoad } from "common/load/utils";
import { stripeCustomFonts } from "common/stripe/fonts";

const key = window.STRIPE_API_KEY;

/**
 * A single shared Stripe.js instance for the client app. Load Stripe once and
 * reuse the same promise everywhere so we never inject the script (or create the
 * Stripe object) more than once.
 */
export const stripePromise = safeLoad(() => loadStripe(key));

/**
 * Options shared by every Stripe `Elements` group in the client app. Kept at the
 * module level so the object identity is stable across renders.
 */
export const stripeElementsOptions = { fonts: stripeCustomFonts };
